import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withRouter from 'components/components/common/withRouter';
import MapPlaces from 'components/components/common/MapPlaces';
import { refreshCustomerAddressesList, setCustomerAddresses }
  from 'components/actions/serviceActions';
import {
  fetchCustomerAddresses,
  fetchBusStops
} from 'components/actions/serviceActions';

class AccountMapContainer extends Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.fetchBusStops();
    this.props.fetchCustomerAddresses();
  }

  render() {
    return (
      <MapPlaces
        busStops={this.props.busStops}
        customerAddresses={this.props.customerAddresses}
        disableCustomerAddresses
        refreshCustomerAddressesList={this.props.refreshCustomerAddressesList}
        setCustomerAddresses={this.props.setCustomerAddresses}
        isMobile={this.props.isMobile}
        locale={this.props.locale}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    busStops: state.service.busStops,
    customerAddresses: state.service.customerAddresses,
    locale: state.app.locale
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      refreshCustomerAddressesList,
      setCustomerAddresses,
      fetchCustomerAddresses,
      fetchBusStops
    }
  )(AccountMapContainer)
);
